<div class="alert" [ngClass]="typeClass">
  <mat-icon class="alert__icon">info</mat-icon>
  <p class="alert__message">
    {{ message }}
  </p>
</div>
